export const barsAndSectors = {
	barsAndSectors: "Bares y Sectores",
	bars: "Bares",
	sectors: "Sectores",
	generalSettings: "Configuraciones Generales",
	printByTableSettings: "Configurar impresión de mesas",
	editSector: "Editar sector",
	createSector: "Crear sector",
	createNewSector: "Crear nuevo sector",
	newSector: "Nuevo sector",
	searchPlaceholderSector: "Buscar por nombre de sector o bar",
	searchPlaceholderAccess: "Buscar por nombre de acceso",
	sectorName: "Nombre del sector",
	sectorBars: "Bares del sector",
	accessControl: "Grupo de acceso",
	createAccess: "Crear acceso",
	newAccess: "Nuevo acceso",
	editAccess: "Editar acceso",
	createNewAccess: "Crear nuevo acceso",
	accessName: "Nombre del acceso",
	initialDate: "Inicio",
	endDate: "Fin",
	range: "Rango de ZigCards",
	zigCardsId: "ID ZigCard",
	downloadModel: "Descargar la plantilla modelo",
	selectFile: "Seleccionar un archivo",
	selectFileDescription: "Tipo de archivo [.xlsx, .xls] hasta [500 mb].",
	removeFile: "Eliminar archivo",
	createAccessSuccess: "Acceso creado con éxito",
	editAccessSuccess: "Acceso editado con éxito",
	name: "Nombre",
	initialDateHour: "Fecha y hora inicial",
	endDateHour: "Fecha y hora final",
	deleteSector: "Eliminar sector",
	deleteSectorSubtitle: "¿Está seguro que desea eliminar el sector?",
	deleteSectorSuccess: "Sector eliminado con éxito",
	editSectorSuccess: "Sector editado con éxito",
	createSectorSuccess: "Sector creado con éxito",
	deleteAccessPolicy: "Eliminar acceso",
	deleteAccessPolicySubtitle: "¿Está seguro que desea eliminar el acceso?",
	deleteAccessPolicySuccess: "Acceso eliminado con éxito",
	editAccessPolicySuccess: "Acceso editado con éxito",
	createAccessPolicySuccess: "Acceso creado con éxito",
	importAccessPolicyTagsSuccess: "IDs importados con éxito",
	accesses: "Accesos",
	sectorAccesses: "Accesos del sector",
	modelFileName: "plantilla-modelo",
	noSectors: "Sin sectores registrados",
	tagIdsError: "Agregue al menos un ID de ZigCard",
	onlySpacesError: "Campo no puede contener solo espacios",
	seeZigCards: "Ver ZigCards",
};
